import React, { useEffect, useState } from 'react'
import { FaBookmark, FaBookOpen, FaPeopleGroup, FaUserGraduate } from 'react-icons/fa6'
import { Link, useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import PropagateLoader from "react-spinners/PropagateLoader"
import { AnnouncementListRes, AnnouncementListTodo } from '../../LMS_Redux/LMS_Slices/Masters/AnnouncementList'
import 'react-perfect-scrollbar/dist/css/styles.css';
import PerfectScrollbar from 'react-perfect-scrollbar'
import PollResultGraph from './PollResultGraph'
import { pollDataRes, pollDataTodo } from '../../LMS_Redux/LMS_Slices/Assets/PollData'
import { useFormik } from 'formik'
import { SubmitPollSchema } from './DashboardSchema'
import { submitPollRes, submitPollTodo } from '../../LMS_Redux/LMS_Slices/Assets/SubmitPoll'
import { ToastContainer, toast } from 'react-toastify'
import TimeSpending from '../LMS_GRAPHS/TimeSpending'
import CourseStatistics from '../LMS_GRAPHS/CourseStatistics'
import { BsArrowDownCircle, BsArrowUpCircle } from 'react-icons/bs'
import AllActivities from '../LMS_GRAPHS/AllActivities'
import UpcomingTrainings from '../LMS_GRAPHS/UpcomingTrainings'
import Calendar from '../LMS_GRAPHS/Calendar'
import { learnerDashboardRes, learnerDashboardTodo } from '../../LMS_Redux/LMS_Slices/Dashboard/LearnerDashboard'
import { learnerBadgeTodo, learnerBadgeRes } from '../../LMS_Redux/LMS_Slices/Dashboard/LearnerBadge'
import LearnerBadge from './LearnerBadge'
import { pointsDetailsRes, pointsDetailsTodo } from '../../LMS_Redux/LMS_Slices/LeaderBoard/PointsDetails'
import { ListGroup, Spinner } from 'react-bootstrap'
import moment from 'moment'

export default function LearnerDashboard() {

    const navigate = useNavigate()
    const dispatch = useDispatch()
    const announcement = useSelector(state => state.announcementList && state.announcementList.data && state.announcementList.data.data)
    const poll = useSelector(state => state.pollData && state.pollData.data && state.pollData.data.data)
    const graph = useSelector(state => state.learnerDashboard && state.learnerDashboard.data && state.learnerDashboard.data.data)
    const badge = useSelector(state => state.learnerBadge && state.learnerBadge.data && state.learnerBadge.data.data)
    const points = useSelector(state => state.pointsDetails && state.pointsDetails.data && state.pointsDetails.data.data)
    const [loading, setLoading] = useState(true)
    const [loadingAnnounce, setLoadingAnnounce] = useState(false)
    const [loadingPoll, setLoadingPoll] = useState(true)
    const [loadingBadge, setLoadingBadge] = useState(true)
    const [loadingPoints, setLoadingPoints] = useState(true)
    const [spinner, setSpinner] = useState(false)
    const [bool, setBool] = useState(false)
    // console.log(badge)

    let user_id = JSON.parse(localStorage.getItem('user_data'))

    const initialValues = {
        poll_option: '',
    }

    const { values, errors, touched, handleBlur, handleChange, handleSubmit, setFieldValue } = useFormik({
        initialValues: initialValues,
        validationSchema: SubmitPollSchema,

        onSubmit: (values, action) => {
            // console.log("new", values)
            setSpinner(true)
            dispatch(submitPollTodo({ 'option': values.poll_option, 'poll_id': poll.id })).then(() => poll_result())
            action.resetForm();
        },
    })

    const poll_result = () => {

        if (submitPollRes && submitPollRes.success) {
            toast.success(submitPollRes.message, { position: "bottom-right" });
            setBool(!bool)
            setSpinner(false)
        } else {
            toast.error(submitPollRes.message, { position: "bottom-right" });
            setBool(!bool)
            setSpinner(false)
        }
    }

    const graph_res = () => {
        if (learnerDashboardRes && learnerDashboardRes.success) {
            setLoading(false)
        } else {
            setLoading(false)
        }
    }

    const announcement_list_res = () => {
        if (AnnouncementListRes && AnnouncementListRes.success) {
            setLoadingAnnounce(false)
        } else {
            setLoadingAnnounce(false)
        }
    }

    const badge_res = () => {
        if (learnerBadgeRes && learnerBadgeRes.success) {
            setLoadingBadge(false)
        } else {
            setLoadingBadge(false)
        }
    }

    const points_res = () => {
        if (pointsDetailsRes && pointsDetailsRes.success) {
            setLoadingPoints(false)
        } else {
            setLoadingPoints(false)
        }
    }

    useEffect(() => {
        setLoading(true)
        setLoadingAnnounce(true)
        setLoadingBadge(true)
        setLoadingPoints(true)
        dispatch(learnerDashboardTodo(user_id.vemp_code)).then(() => graph_res())
        dispatch(AnnouncementListTodo(new Date())).then(() => announcement_list_res())
        dispatch(learnerBadgeTodo(user_id.vemp_code)).then(() => badge_res())
        dispatch(pointsDetailsTodo(user_id.vemp_code)).then(() => points_res())
    }, [])

    const poll_res = () => {
        if (pollDataRes && pollDataRes.success) {
            setLoadingPoll(false)
        } else {
            setLoadingPoll(false)
        }
    }

    useEffect(() => {
        setLoadingPoll(true)
        dispatch(pollDataTodo()).then(() => poll_res())
    }, [bool])

    return (
        <>
            <div className='container-fluid'>
                {loading ?
                    <div className='row'>
                        <div className="col mt-2 mt-md-4 mt-lg-0">
                            <div className='box'>
                                <div className='text-center mb-3'>
                                    <PropagateLoader
                                        color="#2262C6"
                                        size={20}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    :
                    <div className='row row-flex'>
                        <div className="col-6 col-md-3 col-lg-2 mt-3 mt-lg-0">
                            <Link to='/learner_course_list'>
                                <div className='box match_height learning-step'>
                                    <div className='row'>
                                        <div className="col">
                                            <span className='box-icon box-icon-color1'><FaBookOpen /></span>
                                        </div>

                                    </div>
                                    <h3 className='mt-4'>{graph && graph.course_count}</h3>
                                    <p className='box-heading text-success-teal'>Learning Modules</p>
                                </div>
                            </Link>
                        </div>

                        <div className="col-6 col-md-3 col-lg-2 mt-3 mt-lg-0">
                            <Link to='/group_list'>
                                <div className='box match_height group-step'>
                                    <div className='row'>
                                        <div className="col">
                                            <span className='box-icon box-icon-color2'><FaPeopleGroup /></span>
                                        </div>

                                    </div>
                                    <h3 className='mt-4'>{graph && graph.group_count}</h3>
                                    <p className='box-heading text-warning'>Groups</p>
                                </div>
                            </Link>
                        </div>

                        <div className="col-6 col-md-3 col-lg-2 mt-3 mt-lg-0">
                            <Link to='/training_list'>
                                <div className='box match_height training-step'>
                                    <div className='row'>
                                        <div className="col">
                                            <span className='box-icon box-icon-color3'><FaUserGraduate /></span>
                                        </div>
                                    </div>
                                    <h3 className='mt-4'>{graph && graph.training_count}</h3>
                                    <p className='box-heading txt-secondary'>Training</p>
                                </div>
                            </Link>
                        </div>

                        <div className="col-6 col-md-3 col-lg-2 mt-3 mt-lg-0 bookmark-step">
                            <div className='box match_height' onClick={() => navigate('/learner_course_list', { state: 'bookmark' })}>
                                <div className='row'>
                                    <div className="col">
                                        <span className='box-icon box-icon-color5'><FaBookmark /></span>
                                    </div>

                                </div>
                                <h3 className='mt-4'>{graph && graph.bookmarkCount}</h3>
                                <p className='box-heading' style={{ color: 'rgba(3, 44, 66, 0.8)' }}>Bookmarks</p>
                            </div>
                        </div>
                    </div>
                }

                <div className="row row-flex">
                    <div className="col-12 col-md-5 mt-4">
                        {loadingAnnounce ?
                            <div className='wrapper-admin'>
                                <div className="widget-heading">
                                    <h5 className="">Announcements</h5>
                                </div>
                                <div className='text-center mb-4'>
                                    <PropagateLoader
                                        color="#2262C6"
                                        size={20}
                                    />
                                </div>
                            </div>
                            :
                            <div className='wrapper-admin match_height'>
                                <div className="anounce-ment">
                                    <div className="widget-heading">
                                        <h5 className="">Announcements</h5>
                                    </div>
                                    <div>
                                        <PerfectScrollbar>
                                            {announcement && announcement.length ?
                                                announcement && announcement.map((value, index) =>
                                                    <div className={index % 2 == 0 ? "card-body bg-primary-subtle rounded p-2" : "card-body bg-warning-subtle rounded p-2"} key={index}>
                                                        <h5 className="card-title">{value.announcement_title}</h5>
                                                        <p>{value.description}</p>
                                                        <p className='badge text-bg-dark'>Date: {moment(value.createdAt).format('DD/MM/YYYY')}</p>
                                                    </div>
                                                )
                                                :
                                                "No Announcement Available"
                                            }
                                        </PerfectScrollbar>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>

                    <div className="col-12 col-md-7 mt-4">
                        <div className='wrapper-admin match_height'>
                            <div className="anounce-ment">
                                <div className="widget-heading">
                                    <h5 className="">Poll</h5>
                                </div>
                                {loadingPoll ?
                                    <div className='text-center mb-4'>
                                        <PropagateLoader
                                            color="#2262C6"
                                            size={20}
                                        />
                                    </div>
                                    :
                                    poll && poll.hasOwnProperty('res') ?
                                        !poll.res ?
                                            <>
                                                <div className='poll_result'>
                                                    <span>{poll && poll.poll_title && poll.poll_title}</span>
                                                </div>

                                                <form onSubmit={(e) => { e.preventDefault(); handleSubmit(); }} method='post'>
                                                    <div className="d-flex justify-content-around align-items-center">
                                                        {poll && poll.poll_option1 &&
                                                            <div className="form-check mt-2">
                                                                <input className="form-check-input form_checkbox" type="radio" name="poll_option"
                                                                    value='A' onChange={handleChange} onBlur={handleBlur}
                                                                />
                                                                <label className="form-check-label" htmlFor="">
                                                                    {poll && poll.poll_option1 && poll.poll_option1}
                                                                </label>
                                                            </div>
                                                        }

                                                        {poll && poll.poll_option2 &&
                                                            <div className="form-check mt-2">
                                                                <input className="form-check-input form_checkbox" type="radio" name="poll_option"
                                                                    value='B' onChange={handleChange} onBlur={handleBlur}
                                                                />
                                                                <label className="form-check-label" htmlFor="">
                                                                    {poll && poll.poll_option2 && poll.poll_option2}
                                                                </label>
                                                            </div>
                                                        }

                                                        {poll && poll.poll_option3 &&
                                                            <div className="form-check mt-2">
                                                                <input className="form-check-input form_checkbox" type="radio" name="poll_option"
                                                                    value='C' onChange={handleChange} onBlur={handleBlur}
                                                                />
                                                                <label className="form-check-label" htmlFor="">
                                                                    {poll && poll.poll_option3 && poll.poll_option3}
                                                                </label>
                                                            </div>
                                                        }

                                                        {poll && poll.poll_option4 &&
                                                            <div className="form-check mt-2">
                                                                <input className="form-check-input form_checkbox" type="radio" name="poll_option"
                                                                    value='D' onChange={handleChange} onBlur={handleBlur}
                                                                />
                                                                <label className="form-check-label" htmlFor="">
                                                                    {poll && poll.poll_option4 && poll.poll_option4}
                                                                </label>
                                                            </div>
                                                        }
                                                    </div>
                                                    {errors.poll_option && touched.poll_option ? (<span className='text-danger form_label' > {errors.poll_option}</span>) : null}

                                                    <div className='text-end mt-4'>
                                                        <button className='btn btn_submit' type='submit' disabled={spinner ? true : false}>Submit
                                                            {spinner ?
                                                                <Spinner
                                                                    as="span"
                                                                    animation="border"
                                                                    size="sm"
                                                                    role="status"
                                                                    aria-hidden="true"
                                                                    className='ms-2'
                                                                />
                                                                : ''
                                                            }</button>
                                                    </div>
                                                </form>
                                            </>
                                            :
                                            <PollResultGraph poll_data={poll} />
                                        :
                                        'No Poll Available'
                                }

                            </div>
                        </div>
                    </div>
                </div>

                <div className="row mt-4 row-flex">
                    <div className="col-12 col-md-6">
                        {loading ?
                            <div className="wrapper-admin">
                                <div className='text-center mb-3'>
                                    <PropagateLoader
                                        color="#2262C6"
                                        size={20}
                                    />
                                </div>
                            </div>
                            :
                            <div className='wrapper-admin match_height time-step'>

                                <TimeSpending graph={graph && graph.time_spending} />

                                <div className="d-flex align-items-center">
                                    <div className="p-2 ">
                                        <BsArrowUpCircle size={20} className='me-3' style={{ color: 'green' }} />
                                    </div>
                                    <div className="p-2 flex-grow-1">
                                        <span className="font-15" style={{ fontWeight: '600' }}>Most Time</span>
                                        {/* <p className="mb-0 font-12 text-muted">Wednesday</p> */}
                                    </div>
                                    <div className="p-2">
                                        <span className="font-13 float-right mt-1 text-info">{graph && graph.most_time}</span>
                                    </div>
                                </div>

                                <div className="d-flex align-items-center">
                                    <div className="p-2 ">
                                        <BsArrowDownCircle size={20} className='me-3' style={{ color: 'red' }} />
                                    </div>
                                    <div className="p-2 flex-grow-1">
                                        <span className="font-15" style={{ fontWeight: '600' }}>Less Time</span>
                                        {/* <p className="mb-0 font-12 text-muted">Wednesday</p> */}
                                    </div>
                                    <div className="p-2">
                                        <span className="font-13 float-right mt-1 text-danger">{graph && graph.less_time}</span>
                                    </div>
                                </div>

                            </div>}
                    </div>
                    <div className="col-12 col-md-6 mt-4 mt-md-0">
                        <div className='wrapper-admin match_height learninggraph-step'>
                            {loading ?
                                <div className='text-center mb-3'>
                                    <PropagateLoader
                                        color="#2262C6"
                                        size={20}
                                    />
                                </div>
                                :
                                <CourseStatistics graph={graph && graph.course_statistics} />
                            }
                        </div>
                    </div>

                </div>

                <div className="row row-flex mt-4">
                    <div className="col-12 col-md-6">
                        {loading ?
                            <div className="wrapper-admin">
                                <div className='text-center mb-3'>
                                    <PropagateLoader
                                        color="#2262C6"
                                        size={20}
                                    />
                                </div>
                            </div>
                            :
                            <div className='match_height'>
                                <AllActivities graph={graph && graph.all_activities} />
                            </div>
                        }
                    </div>

                    <div className="col-12 col-md-6">
                        {loading ?
                            <div className="wrapper-admin">
                                <div className='text-center mb-3'>
                                    <PropagateLoader
                                        color="#2262C6"
                                        size={20}
                                    />
                                </div>
                            </div>
                            :
                            <div className='match_height'>
                                <UpcomingTrainings graph={graph && graph.upcoming_training} />
                            </div>
                        }
                    </div>
                </div>

                <div className="row mt-4">
                    <div className="col-md-6">
                        {loadingBadge ?
                            <div className="wrapper-admin">
                                <div className='text-center mb-3'>
                                    <PropagateLoader
                                        color="#2262C6"
                                        size={20}
                                    />
                                </div>
                            </div>
                            :
                            <div className="wrapper-admin badge-step">
                                <div className='dash_head'>
                                    <h5>Badges</h5>
                                </div>
                                <PerfectScrollbar options={{ suppressScrollX: true }} style={{ height: '35vh' }}>
                                    <LearnerBadge badge={badge} />
                                </PerfectScrollbar>
                            </div>
                        }
                    </div>

                    <div className="col-md-6">
                        {loadingPoints ?
                            <div className="wrapper-admin">
                                <div className='text-center mb-3'>
                                    <PropagateLoader
                                        color="#2262C6"
                                        size={20}
                                    />
                                </div>
                            </div>
                            :
                            <div className="wrapper-admin">
                                <div className='dash_head'>
                                    <h5>Point Detail's</h5>
                                </div>
                                <PerfectScrollbar options={{ suppressScrollX: true }} style={{ height: '35vh' }}>
                                    <ListGroup as="ol" >
                                        {points && points.userPoints && points.userPoints.map((val, index) =>
                                            <ListGroup.Item
                                                as="li"
                                                className="d-flex justify-content-between align-items-center"
                                                key={index}
                                            >
                                                <div className="fw-bold" style={{ color: 'rgba(34, 98, 198, 0.4)' }}>{index + 1}</div>
                                                <div className="ms-4 me-auto">
                                                    <div className="">{val && val.lms_master_point && val.lms_master_point.point_type}</div>
                                                    {val && val.user && val.user.vdepartment_name}
                                                </div>
                                                <div className="fw-bold" style={{ color: '#2262C6' }}>{val && val.point_sum}</div>
                                            </ListGroup.Item>
                                        )}
                                    </ListGroup>
                                </PerfectScrollbar>
                            </div>
                        }
                    </div>
                </div>

                <div className="row mt-4">
                    <div className="col-md-12">
                        {loading ?
                            <div className="wrapper-admin">
                                <div className='text-center mb-3'>
                                    <PropagateLoader
                                        color="#2262C6"
                                        size={20}
                                    />
                                </div>
                            </div>
                            :
                            <div className="wrapper-admin calendar-step">
                                <Calendar calendar={graph && graph.calender_data} />
                            </div>}
                    </div>
                </div>
            </div >
        </>
    )
}
